import React, { useState, useEffect } from "react";
import { useAuth } from './AuthContext';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup"

const validationSchema = yup.object({
    username: yup.string().required("User Name is required"),
    email: yup.string().email("Invalid email format").required("Email is required"),
    selRoles: yup.array()
        .min(1, 'Please select at least one role for user')
        .required('Required'),
}).required()

export default function EditUser() {
    const [user, setUser] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userRoles, setUserRoles] = useState([]);
    const { secureFetch } = useAuth();
    const navigate = useNavigate();
    // Destructure the parameter name you defined in the Route path
    const { userId } = useParams();

    const { register, handleSubmit, formState: { errors } } = useForm({
        resolver: yupResolver(validationSchema),
        values: user, // Automatically populates when data is available
    })

    var screenHeader = '';
    if (userId)
        screenHeader = "Update User";
    else
        screenHeader = "Create New User";

    useEffect(() => {
        var myAsyncFunction = async () => {
            var response = await secureFetch('api/auth/roles');
            if (response.ok) {
                const data = await response.json();
                setRoles(data);
            }

            if (userId) {
                let userData = {};
                response = await secureFetch(`api/auth/user/${userId}`);
                if (response.ok) {
                    userData = await response.json();
                    setUser(userData);

                    const userRoles = userData.roles.map(ur => ur.roleName);
                    setUserRoles(userRoles);
                }
            }
            else {
                let defaultRoles = [{ roleId: null, rollName: 'RegularUser', userId: null, user: null }];
                let newUserInfo = {
                    id: null,
                    username: null,
                    email: null,
                    roles: defaultRoles
                };
                setUser(newUserInfo);
                setUserRoles(defaultRoles.map(r => r.rollName)); //default role for user in insert mode
            }
        }
        myAsyncFunction();
    }, []);

    function roleSelectionChanged(e) {
        let roleName = e.target.value;
        let isChecked = e.target.checked;
        //alert(`Role ${roleName} is checked: ${isChecked}`);
        if (isChecked) {
            if (userRoles.indexOf(roleName) == -1) {
                let newRoles = [...userRoles, roleName]; //Add the checked item
                setUserRoles(newRoles);
            }
        }
        else {
            if (userRoles.indexOf(roleName) > -1) {
                let newRoles = userRoles.filter(item => item !== roleName); //Remove the unchecked item
                setUserRoles(newRoles);
            }
        }
    }

    function navigateBack(e) {
        navigate('/admin/users');
    }

    async function onSubmit(data) {
        //alert('OA OA');
        console.log('Selected Roles:', userRoles);
        console.log('Form Data:', data);
        //build the payload
        let payload = {
            id: userId ? data.id : null,
            username: data.username,
            email: data.email,
            roles: userRoles.map(ur => { return { roleName: ur } })
        };
        let createOrUpdate = data.id ? 'update' : 'create';

        const response = await secureFetch('api/auth/user/' + createOrUpdate, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });
        if (response.ok) {
            alert(`User ${createOrUpdate}d successfully.`);
            navigateBack();
        } else {
            alert(`Failed to ${createOrUpdate} user.`);
        }
    }

    function renderRolesCheckboxes() {
        let rolesCheckboxes = roles.map((curRole) => (
            <div class="checkbox" key={curRole.id}>
                <label asp-for="curRole.id" class="form-label">
                    {curRole.name}
                    <input type="checkbox" {...register('selRoles')} style={{ marginLeft: '5px', display: 'inline-block' }}
                        value={curRole.name} checked={(userRoles.indexOf(curRole.name) > -1)} onChange={roleSelectionChanged} />
                </label>
            </div>
        ));
        if (rolesCheckboxes.length > 0) {
            rolesCheckboxes.push(<div>&nbsp; {errors.selRoles && <span className="text-danger">{errors.selRoles.message}</span>}</div>);
        }
        else {
            rolesCheckboxes.push(<dl class="dl-horizontal"><dd>No roles defined</dd></dl>);
        }
        return rolesCheckboxes;
    }


    return (
        <>
            <div className="form-horizontal">
                <form onSubmit={handleSubmit(onSubmit)}>
                    <h4>{screenHeader}</h4>
                    <hr />
                    <h5>User Details</h5>
                    <div className="form-floating mb-2">
                        <input {...register("username")} class="form-control" autocomplete="username" aria-required="true" />
                        <label for="userName" className="form-label">User Name</label>
                        <div>&nbsp; {errors.username && <span className="text-danger">{errors.username.message}</span>}</div>
                    </div>
                    <div className="form-floating mb-2">
                        <input {...register("email")} className="form-control" autocomplete="on" aria-required="true" />
                        <label for="email" className="form-label">Email</label>
                        <div>&nbsp; {errors.email && <span className="text-danger">{errors.email.message}</span>}</div>
                    </div>
                    {/*<div className="form-group form-row">*/}
                    {/*    <div className="checkbox">*/}
                    {/*        <label for="emailConfirmed" class="form-label">*/}
                    {/*            Email Confirmed*/}
                    {/*            <input className="form-check-input" name="emailConfirmed" />*/}
                    {/*        </label>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div className="form-group form-row">*/}
                    {/*    <label for="phoneNumber" class="control-label col-md-2"></label>*/}
                    {/*    <div class="col-md-10">*/}
                    {/*        <input name="phoneNumber" class="form-control" autocomplete="on" aria-required="true" />*/}
                    {/*        <span asp-validation-for="phoneNumber" class="text-danger"></span>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div class="form-group form-row">*/}
                    {/*    <div class="checkbox">*/}
                    {/*        <label for="phoneNumberConfirmed" class="form-label">*/}
                    {/*            Phone Number Confirmed*/}
                    {/*            <input class="form-check-input" name="phoneNumberConfirmed" />*/}
                    {/*        </label>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div class="form-group form-row">*/}
                    {/*    <div class="checkbox">*/}
                    {/*        <label asp-for="Input.TwoFactorEnabled" class="form-label">*/}
                    {/*            @Html.DisplayNameFor(m => m.Input.TwoFactorEnabled)*/}
                    {/*            <input class="form-check-input" asp-for="Input.TwoFactorEnabled" />*/}
                    {/*        </label>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div class="form-group form-row">*/}
                    {/*    <div class="checkbox">*/}
                    {/*        <label asp-for="Input.LockoutEnabled" class="form-label">*/}
                    {/*            @Html.DisplayNameFor(m => m.Input.LockoutEnabled)*/}
                    {/*            <input class="form-check-input" asp-for="Input.LockoutEnabled" />*/}
                    {/*        </label>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    {/*<div class="form-group form-row">*/}
                    {/*    <label asp-for="Input.LockoutEnd" class="control-label col-md-2"></label>*/}
                    {/*    <div class="col-md-10">*/}
                    {/*        <input asp-for="Input.LockoutEnd" class="form-control" autocomplete="username" aria-required="true" />*/}
                    {/*        <span asp-validation-for="Input.LockoutEnd" class="text-danger"></span>*/}
                    {/*    </div>*/}
                    {/*</div>*/}
                    <h5>User Roles</h5>
                    { renderRolesCheckboxes() }
                    <div className="form-group form-row mt-4">
                        <div class="d-flex justify-content-start">
                                <button id="user-submit" type="submit" class="btn btn-lg btn-primary">Save</button>
                                <button id="user-cancel" type="button" class="btn btn-lg btn-primary ms-3" onClick={ navigateBack }>Cancel</button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}